module.exports = __webpack_public_path__ + "static/media/Logo Lingkar Baca (Circle).0b43f765.png";